import { connect } from 'react-redux';
import RouteStopsImport from './RouteStopsImport';
import { IRootState } from '../../../redux/state';
import { IUser } from '../../../models';
import { bindActionCreators, Dispatch } from 'redux';
import { setImportedRouteStops } from '../../../redux/modules/route/routeCreators';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    isLoading: state.route.isRouteListLoading,
    routesOverview: state.route.routesOverview,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setImportedRouteStops: bindActionCreators(setImportedRouteStops, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteStopsImport);
